import * as CartActionTypes from '../actionTypes/CartActionTypes';

export const getCartDetails = (headers) => ({
    type: CartActionTypes.CART_DETAILS_GET_REQUEST,
    headers,
});
export const logMetaUADetails = (headers) => ({
    type: CartActionTypes.LOG_META_UA,
    headers,
});
export default { getCartDetails, logMetaUADetails };
